import { render, staticRenderFns } from "./SidebarBlockGroup.vue?vue&type=template&id=7509540a"
import script from "./SidebarBlockGroup.vue?vue&type=script&lang=ts"
export * from "./SidebarBlockGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports